import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import SiteHeader from "@/components/SiteHeader";
import Seo from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";
import { SECTIONS_PT, SECTIONS_EN } from "./termosContent";

export default function TermosPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const pt = language !== "en";
  const SECTIONS = pt ? SECTIONS_PT : SECTIONS_EN;

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Poppins', 'Montserrat', sans-serif" }}>
      <SiteHeader active="" onBuyClick={() => navigate("/#passport")} />
      <Seo
        title={pt ? "Termos e Condições Gerais" : "General Terms and Conditions"}
        description={pt ? "Termos e Condições Gerais de utilização e compra da plataforma PASS Algarve." : "General Terms and Conditions for using and purchasing on the PASS Algarve platform."}
      />

      {/* Hero */}
      <section className="bg-[#071A35] pt-28 pb-12" data-testid="terms-hero">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#D4A85D] text-xs font-bold uppercase tracking-[0.25em] mb-3">PASS ALGARVE</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
            {pt ? "Termos e Condições Gerais" : "General Terms and Conditions"}
          </h1>
          <p className="text-white/60 text-sm">{pt ? "Última atualização: 1 de setembro de 2026" : "Last updated: September 1, 2026"}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 lg:py-16 bg-white flex-1" data-testid="terms-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-[#071A35]/80 text-sm leading-relaxed space-y-4 mb-10">
            <p className="text-[#071A35] font-semibold text-base">{pt ? "Bem-vindo ao PASS Algarve." : "Welcome to PASS Algarve."}</p>
            {pt ? (
              <>
                <p>
                  Os presentes Termos e Condições Gerais regulam o acesso e utilização da plataforma PASS Algarve, incluindo o
                  website passalgarve.com, a criação e utilização da conta de cliente, a aquisição de Passaportes, reservas,
                  vouchers, QR Codes e o acesso às atrações, atividades e experiências disponibilizadas pelos nossos parceiros.
                </p>
                <p>
                  Ao criar uma conta, adquirir um PASS ou utilizar os serviços disponibilizados através da plataforma, o
                  utilizador declara que leu, compreendeu e aceita os presentes Termos e Condições.
                </p>
              </>
            ) : (
              <>
                <p>
                  These General Terms and Conditions govern access to and use of the PASS Algarve platform, including the
                  passalgarve.com website, the creation and use of customer accounts, the purchase of Passports, bookings,
                  vouchers, QR Codes and access to the attractions, activities and experiences made available by our partners.
                </p>
                <p>
                  By creating an account, purchasing a PASS or using the services made available through the platform, the
                  user declares that they have read, understood and accept these Terms and Conditions.
                </p>
              </>
            )}
          </div>

          <div className="space-y-10">
            {SECTIONS.map((s, i) => (
              <div key={i} data-testid={`terms-section-${i + 1}`}>
                <h2 className="text-[#071A35] font-bold text-lg mb-3 pb-2 border-b border-[#D4A85D]/30">{s.title}</h2>
                <div className="text-[#071A35]/80 text-sm leading-relaxed space-y-3">
                  {s.paras.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                  {s.list && (
                    <ul className="list-none space-y-1.5 pl-1">
                      {s.list.map((li, k) => (
                        <li key={k} className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 rounded-full bg-[#D4A85D] mt-1.5 flex-shrink-0" />
                          {li}
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.parasAfter && s.parasAfter.map((p, j) => <p key={`a${j}`}>{p}</p>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
